var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefinementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5845_162687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99951 11C7.20386 11 6.4408 10.6839 5.87819 10.1213C5.31558 9.55871 4.99951 8.79565 4.99951 8C4.99951 7.86739 4.94683 7.74022 4.85307 7.64645C4.7593 7.55268 4.63212 7.5 4.49951 7.5C4.3669 7.5 4.23973 7.55268 4.14596 7.64645C4.05219 7.74022 3.99951 7.86739 3.99951 8C3.99951 8.79565 3.68344 9.55871 3.12083 10.1213C2.55822 10.6839 1.79516 11 0.999512 11C0.866903 11 0.739726 11.0527 0.645958 11.1464C0.55219 11.2402 0.499512 11.3674 0.499512 11.5C0.499512 11.6326 0.55219 11.7598 0.645958 11.8536C0.739726 11.9473 0.866903 12 0.999512 12C1.79516 12 2.55822 12.3161 3.12083 12.8787C3.68344 13.4413 3.99951 14.2044 3.99951 15C3.99951 15.1326 4.05219 15.2598 4.14596 15.3536C4.23973 15.4473 4.3669 15.5 4.49951 15.5C4.63212 15.5 4.7593 15.4473 4.85307 15.3536C4.94683 15.2598 4.99951 15.1326 4.99951 15C4.99951 14.2044 5.31558 13.4413 5.87819 12.8787C6.4408 12.3161 7.20386 12 7.99951 12C8.13212 12 8.2593 11.9473 8.35307 11.8536C8.44683 11.7598 8.49951 11.6326 8.49951 11.5C8.49951 11.3674 8.44683 11.2402 8.35307 11.1464C8.2593 11.0527 8.13212 11 7.99951 11Z",
    fill: "url(#paint0_linear_5845_162687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 6.25C14.4032 6.24868 13.8317 6.0112 13.41 5.58953C12.9883 5.16786 12.7508 4.59633 12.7495 4C12.7495 3.86739 12.6968 3.74022 12.6031 3.64645C12.5093 3.55268 12.3821 3.5 12.2495 3.5C12.1169 3.5 11.9897 3.55268 11.896 3.64645C11.8022 3.74022 11.7495 3.86739 11.7495 4C11.7482 4.59633 11.5107 5.16786 11.089 5.58953C10.6674 6.0112 10.0958 6.24868 9.49951 6.25C9.3669 6.25 9.23973 6.30268 9.14596 6.39645C9.05219 6.49022 8.99951 6.61739 8.99951 6.75C8.99951 6.88261 9.05219 7.00979 9.14596 7.10355C9.23973 7.19732 9.3669 7.25 9.49951 7.25C10.0958 7.25132 10.6674 7.4888 11.089 7.91047C11.5107 8.33214 11.7482 8.90367 11.7495 9.5C11.7495 9.63261 11.8022 9.75979 11.896 9.85355C11.9897 9.94732 12.1169 10 12.2495 10C12.3821 10 12.5093 9.94732 12.6031 9.85355C12.6968 9.75979 12.7495 9.63261 12.7495 9.5C12.7508 8.90367 12.9883 8.33214 13.41 7.91047C13.8317 7.4888 14.4032 7.25132 14.9995 7.25C15.1321 7.25 15.2593 7.19732 15.3531 7.10355C15.4468 7.00979 15.4995 6.88261 15.4995 6.75C15.4995 6.61739 15.4468 6.49022 15.3531 6.39645C15.2593 6.30268 15.1321 6.25 14.9995 6.25Z",
    fill: "url(#paint1_linear_5845_162687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99951 3C5.39734 3 5.77887 3.15804 6.06017 3.43934C6.34148 3.72064 6.49951 4.10218 6.49951 4.5C6.49951 4.63261 6.55219 4.75979 6.64596 4.85355C6.73973 4.94732 6.8669 5 6.99951 5C7.13212 5 7.2593 4.94732 7.35307 4.85355C7.44683 4.75979 7.49951 4.63261 7.49951 4.5C7.49951 4.10218 7.65755 3.72064 7.93885 3.43934C8.22016 3.15804 8.60169 3 8.99951 3C9.13212 3 9.2593 2.94732 9.35307 2.85355C9.44683 2.75978 9.49951 2.63261 9.49951 2.5C9.49951 2.36739 9.44683 2.24022 9.35307 2.14645C9.2593 2.05268 9.13212 2 8.99951 2C8.60169 2 8.22016 1.84196 7.93885 1.56066C7.65755 1.27936 7.49951 0.897825 7.49951 0.5C7.49951 0.367392 7.44683 0.240215 7.35307 0.146447C7.2593 0.0526784 7.13212 0 6.99951 0C6.8669 0 6.73973 0.0526784 6.64596 0.146447C6.55219 0.240215 6.49951 0.367392 6.49951 0.5C6.49951 0.897825 6.34148 1.27936 6.06017 1.56066C5.77887 1.84196 5.39734 2 4.99951 2C4.8669 2 4.73973 2.05268 4.64596 2.14645C4.55219 2.24022 4.49951 2.36739 4.49951 2.5C4.49951 2.63261 4.55219 2.75978 4.64596 2.85355C4.73973 2.94732 4.8669 3 4.99951 3Z",
    fill: "url(#paint2_linear_5845_162687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 15.5C10.2757 15.5 10.4995 15.2761 10.4995 15C10.4995 14.7239 10.2757 14.5 9.99951 14.5C9.72337 14.5 9.49951 14.7239 9.49951 15C9.49951 15.2761 9.72337 15.5 9.99951 15.5Z",
    fill: "url(#paint3_linear_5845_162687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49951 9C7.77565 9 7.99951 8.77614 7.99951 8.5C7.99951 8.22386 7.77565 8 7.49951 8C7.22337 8 6.99951 8.22386 6.99951 8.5C6.99951 8.77614 7.22337 9 7.49951 9Z",
    fill: "url(#paint4_linear_5845_162687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.49951 6.5C1.77565 6.5 1.99951 6.27614 1.99951 6C1.99951 5.72386 1.77565 5.5 1.49951 5.5C1.22337 5.5 0.999512 5.72386 0.999512 6C0.999512 6.27614 1.22337 6.5 1.49951 6.5Z",
    fill: "url(#paint5_linear_5845_162687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 3C13.7757 3 13.9995 2.77614 13.9995 2.5C13.9995 2.22386 13.7757 2 13.4995 2C13.2234 2 12.9995 2.22386 12.9995 2.5C12.9995 2.77614 13.2234 3 13.4995 3Z",
    fill: "url(#paint6_linear_5845_162687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1095 12.8503C14.3856 12.8503 14.6095 12.6264 14.6095 12.3503C14.6095 12.0741 14.3856 11.8503 14.1095 11.8503C13.8334 11.8503 13.6095 12.0741 13.6095 12.3503C13.6095 12.6264 13.8334 12.8503 14.1095 12.8503Z",
    fill: "url(#paint7_linear_5845_162687)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5845_162687",
    x1: 7.99951,
    y1: 0,
    x2: 7.99951,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5845_162687",
    x1: 7.99951,
    y1: 0,
    x2: 7.99951,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5845_162687",
    x1: 7.99951,
    y1: 0,
    x2: 7.99951,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5845_162687",
    x1: 7.99951,
    y1: 0,
    x2: 7.99951,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5845_162687",
    x1: 7.99951,
    y1: 0,
    x2: 7.99951,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5845_162687",
    x1: 7.99951,
    y1: 0,
    x2: 7.99951,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5845_162687",
    x1: 7.99951,
    y1: 0,
    x2: 7.99951,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5845_162687",
    x1: 7.99951,
    y1: 0,
    x2: 7.99951,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AF3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5845_162687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinementIcon);
export default __webpack_public_path__ + "static/media/refinement_icon.6bc3b80c75407b4d8494a506866ce17b.svg";
export { ForwardRef as ReactComponent };